import { render, staticRenderFns } from "./TemplateInput.vue?vue&type=template&id=8cbe2ffe&scoped=true"
import script from "./TemplateInput.vue?vue&type=script&lang=js"
export * from "./TemplateInput.vue?vue&type=script&lang=js"
import style0 from "./TemplateInput.vue?vue&type=style&index=0&id=8cbe2ffe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbe2ffe",
  null
  
)

export default component.exports